import { Skeleton } from '@shared/components/ui/shadcn';

export const PlanSkeleton = () => {
  return (
    <div className="space-y-4 mb-6 pb-8 gap-4 grid grid-cols-1 md:grid-cols-5 pt-4 border-b border-card-border">
      <div className="col-span-1 md:col-span-2">
        <Skeleton className="h-5 w-40 bg-hover-press" />
      </div>
      <div className="col-span-1 md:col-span-3 !mt-0 space-y-4">
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:gap-4">
          <div className="flex flex-row items-center gap-3 flex-1 min-w-0">
            <Skeleton className="w-14 h-14 rounded-full bg-hover-press" />
            <div className="flex flex-col flex-1 min-w-0 gap-2">
              <Skeleton className="h-5 w-48 bg-hover-press" />
              <Skeleton className="h-4 w-32 bg-hover-press" />
            </div>
          </div>
          <Skeleton className="h-11 w-44 rounded-md bg-hover-press" />
        </div>
        <div className="flex items-center gap-4 border border-card-border rounded-lg px-4 py-3">
          <Skeleton className="w-4 h-4 rounded-full bg-hover-press" />
          <Skeleton className="h-4 w-full bg-hover-press" />
        </div>
      </div>
    </div>
  );
};
